<ng-container *ngIf="viewModel$ | async as viewModel">
  <p-dialog
    [header]="viewModel.header"
    [visible]="viewModel.visible"
    [style]="viewModel.style"
    [modal]="true"
    (visibleChange)="store.dispatch(actions.exitButtonClicked())"
  >
    <ng-template pTemplate="content">
      <ng-container [ngSwitch]="viewModel.view">
        <div
          *ngSwitchCase="'loading'"
          class="p-d-flex p-jc-center p-ai-center p-p-4"
        >
          <p-progressSpinner strokeWidth="4"></p-progressSpinner>
        </div>
        <div
          *ngSwitchCase="'cancel'"
          class="jobsv2-{{ colorScheme.colorScheme.value }}"
        >
          <p>{{ viewModel.cancelPrompt }}</p>
          <div
            *ngFor="let event of viewModel.bookedEvents"
            class="event-card card p-mb-2"
            (click)="
              store.dispatch(actions.eventCardClicked({ eventId: event.id }))
            "
          >
            <div class="event-card-checkbox">
              <p-checkbox
                [binary]="true"
                [ngModel]="event.selected"
              ></p-checkbox>
            </div>
            <div class="event-card-details">
              <span>{{ event.title }}</span>
              <small>{{ event.details }}</small>
            </div>
          </div>
          <div class="section-footer p-text-right">
            <button
              pButton
              [label]="viewModel.continueButton.label"
              [disabled]="viewModel.continueButton.disabled"
              (click)="
                store.dispatch(
                  actions.continueButtonClicked({
                    command: viewModel.continueButton.command,
                  })
                )
              "
              [icon]="viewModel.continueButton.icon"
              iconPos="right"
            ></button>
          </div>
        </div>
        <div *ngSwitchCase="'close'">
          <p>{{ viewModel.closePrompt }}</p>
          <p-listbox
            [options]="viewModel.closureReasons"
            optionLabel="title"
            optionValue="id"
            [ngModel]="viewModel.closedReason"
            [filter]="true"
            (ngModelChange)="
              store.dispatch(
                actions.closureReasonSelected({ closedReason: $event })
              )
            "
          ></p-listbox>
          <p-message
            *ngIf="viewModel.closeBlocker; else payLinkWarning"
            severity="error"
            [text]="viewModel.closeBlocker"
            styleClass="p-d-flex p-jc-start p-mt-3"
          ></p-message>
          <ng-template #payLinkWarning>
            <p-message
              *ngIf="viewModel.payLinkWarning"
              severity="warn"
              [text]="viewModel.payLinkWarning"
              styleClass="p-d-flex p-jc-start p-mt-3"
            ></p-message>
          </ng-template>
          <div class="section-footer p-d-flex p-jc-between">
            <button
              pButton
              label="Back"
              icon="pi pi-arrow-left"
              [outlined]="true"
              severity="secondary"
              (click)="store.dispatch(actions.backButtonClicked())"
            ></button>
            <div class="p-d-flex p-ai-center" style="gap: 0.5rem">
              <button
                pButton
                [outlined]="true"
                severity="secondary"
                [label]="viewModel.cancelEventsOnlyButton.label"
                [disabled]="viewModel.cancelEventsOnlyButton.disabled"
                [icon]="viewModel.cancelEventsOnlyButton.icon"
                (click)="
                  store.dispatch(actions.cancelEventsOnlyButtonClicked())
                "
              ></button>
              <button
                pButton
                class="p-button-success"
                [label]="viewModel.closeJobButton.label"
                [disabled]="viewModel.closeJobButton.disabled"
                [icon]="viewModel.closeJobButton.icon"
                (click)="store.dispatch(actions.closeJobButtonClicked())"
              ></button>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-template>
  </p-dialog>
</ng-container>
